<template>
  <div class="elecSettleUser">
    <el-card class="topCard">
      <div class="title">「{{ uname }}」{{ month }}月缴费账单</div>
      <div class="findInput">
        <el-select v-model="cycle" clearable placeholder="请选择周期" style="margin-right: 10px">
          <el-option v-for="item in dateOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-button @click="getBill">查询</el-button>
      </div>
    </el-card>
    <el-card class="bottomCard">
      <div slot="header" class="clearfix">
        <el-descriptions class="margin-top" title="账单详情" :column="4" border>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              电费类型
            </template>
            基本电费
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              电量
            </template>
            {{ detailsData.jibendianfeidianliang }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              单价
            </template>
            {{ detailsData.jibendianfeidanjia || 0.8 }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-location-outline"></i>
              电费合计
            </template>
            {{ detailsData.electricjPrc }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              电费类型
            </template>
            峰-交易电费
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              电量
            </template>
            {{ detailsData.electricf }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              单价
            </template>
            {{ detailsData.fengdanjia }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-location-outline"></i>
              电费合计
            </template>
            {{ detailsData.fengdanjiaHeji }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              电费类型
            </template>
            平-交易电费
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              电量
            </template>
            {{ detailsData.electricp }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              单价
            </template>
            {{ detailsData.pingdanjia }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-location-outline"></i>
              电费合计
            </template>
            {{ detailsData.pingdanjiaHeji }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              电费类型
            </template>
            谷-交易电费
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              电量
            </template>
            {{ detailsData.electricg }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              单价
            </template>
            {{ detailsData.gudanjia }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-location-outline"></i>
              电费合计
            </template>
            {{ detailsData.gudanjiaHeji }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              电费类型
            </template>
            力调电费
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              电量
            </template>
            {{ detailsData.electricw || 0 }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              单价
            </template>
            {{ 0 }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-location-outline"></i>
              电费合计
            </template>
            {{ detailsData.electricwPrc || 0 }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="cardBody">
        <div class="cardBody-top">
          <!-- 您的电费将根据
          <div><img :src="imgSrc" alt="" /></div> -->

          本期{{ detailsData.status == 1 ? "已" : "需" }}缴费金额总计：
          <span>{{ this.basicCharge }}</span>
          元
        </div>
        <div class="cardBody-bottom">
          <el-button :disabled="detailsData.status == 1" class="btn" @click="handlePay">{{ detailsData.status == 1 ? "已"
            :
            "立即" }}缴费</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getBillData } from "@/api/electricitySettlement.js";
import url from "@/assets/imgs/equation.png";
import { generatePaymentCodeApi } from "@/api/energyManagement.js";
export default {
  name: "ElecSettleZhuan",
  components: {},
  async mounted() {
    // this.generatePaymentCodeEv();
    // this.generateMonthList();
    this.generateMonthList2()
    this.getBill();
  },
  data() {
    return {
      month: "",
      dateOption: [],
      cycle: "",
      basicCharge: 0,
      imgSrc: url,
      // tableData: [],
      detailsData: {},
      uname: sessionStorage.getItem("uname"),
    };
  },
  methods: {
    generatePaymentCodeEv() {
      generatePaymentCodeApi().then((res) => {
        this.basicCharge = res.money;
      });
    },
    handlePay() {
      this.jumpFn("/electricitysettlement/userSettle", {
        basicCharge: this.basicCharge,
      });
    },
    async getBill() {
      let params = {
        type: 2,
        dateMonth: this.cycle,
      };
      const res = await getBillData(params);

      if (res.code === 200) {
        this.month = this.cycle.split("-")[1];
        // this.tableData = res.data;
        this.detailsData = res.data[0];

        this.basicCharge = this.detailsData.zonheji;
      } else {
        this.$message.warning(res.msg);
      }
    },
    generateMonthList() {
      const today = new Date();
      const monthsList = [];

      for (let i = 1; i <= 6; i++) {
        const pastMonth = new Date(
          today.getFullYear(),
          today.getMonth() - i,
          1
        );
        const formattedMonth = `${pastMonth.getFullYear()}-${String(
          pastMonth.getMonth() + 1
        ).padStart(2, "0")}`;
        const monthLabel = `${pastMonth.getFullYear()}年${pastMonth.getMonth() + 1
          }月`;

        monthsList.push({ value: formattedMonth, label: monthLabel });
      }
      this.dateOption = monthsList;
      this.cycle = monthsList[0].value;
      console.log(monthsList, "month--");
    },
    generateMonthList2() {
      this.dateOption = [
        { label: "2024年8月", value: "2024-08" },
        { label: "2024年7月", value: "2024-07" },
        { label: "2024年6月", value: "2024-06" },
        { label: "2024年5月", value: "2024-05" },
        { label: "2024年4月", value: "2024-04" },
      ];
      this.cycle = this.dateOption[0].value;
    },
  },
};
</script>

<style lang="scss" scoped>
.elecSettleUser {
  max-width: 1872px;
  margin: 0 auto;
  padding-top: 20px;
  box-sizing: border-box;

  .topCard {
    width: 100%;
    height: 64px;
    font-size: 18px;
    font-weight: 600;

    .title {
      float: left;
    }

    .findInput {
      float: right;
      display: flex;
      position: relative;
      top: -6px;

      .el-button {
        background: #068d6c;
        color: #fff;
      }
    }
  }

  .bottomCard {
    height: auto;
    max-height: 878px;
    margin-top: 20px;

    .clearfix {
      height: auto;
    }

    .cardBody {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;

      .cardBody-top {
        margin-top: 60px;
        font-size: 20px;
        font-weight: 600;
        color: #000;
        display: flex;
        align-items: center;

        >div {
          margin: 0 20px;
          position: relative;

          &::after {
            content: "电费分摊计算公式";
            width: 120px;
            font-size: 14px;
            position: absolute;
            bottom: -40px;
            left: 50%;
            transform: translate(-50%, 0);
          }
        }

        >span {
          font-size: 60px;
          color: #ec790a;
          margin: 0 15px;
        }
      }

      .cardBody-bottom {
        width: 100%;

        .btn {
          width: 280px;
          height: 60px;
          float: right;
          font-size: 20px;
          color: #fff;
          font-weight: 600;
          background-color: #068d6c;
        }
      }
    }
  }
}
</style>
